import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { HorizontalComponent } from './layouts/horizontal/horizontal.component';
import { AppRoutingModule } from './app-routing.module';
import { FooterComponent } from './components/footer/footer.component';
import { TopbarComponent } from './components/topbar/topbar.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { MenuModule } from 'primeng/menu';
import { ToastModule } from 'primeng/toast';
import { AvatarModule } from 'primeng/avatar';
import { SidebarModule } from 'primeng/sidebar';
import { BadgeModule } from 'primeng/badge';
import { StyleClassModule } from 'primeng/styleclass';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { DividerModule } from 'primeng/divider';
import { TranslocoRootModule } from './transloco-root.module';

import { DATE_PIPE_DEFAULT_OPTIONS, registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { JWTInterceptor } from './interceptors/jwt.interceptor';
import { LangInterceptor } from './interceptors/lang.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';

registerLocaleData(localeIt);


@NgModule({
  declarations: [
    AppComponent,
    HorizontalComponent,
    FooterComponent,
    TopbarComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    MenuModule,
    BrowserAnimationsModule,
    ToastModule,
    AvatarModule,
    BadgeModule,
    TranslocoRootModule,
    SidebarModule,
    StyleClassModule,
    TieredMenuModule,
    DividerModule
  ],
  providers: [
    { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { timezone: 'UTC+01:00' } },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JWTInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LangInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
